var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserSquare = function SvgUserSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user-square_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M2.667 14.545c.402.122.944.122 1.867.122h6.933c.922 0 1.465 0 1.867-.122m-10.667 0a1.5 1.5 0 0 1-.241-.096 2 2 0 0 1-.875-.874c-.218-.428-.218-.988-.218-2.108V4.534c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .875-.875c.427-.218.987-.218 2.108-.218h6.933c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.875c.218.427.218.987.218 2.108v6.933c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874 1.5 1.5 0 0 1-.241.096m-10.667 0c0-.54.003-.825.051-1.065a2.67 2.67 0 0 1 2.095-2.095c.258-.051.568-.051 1.187-.051h4c.62 0 .93 0 1.187.05a2.67 2.67 0 0 1 2.095 2.096c.048.24.051.526.052 1.065m-2.667-8.211a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user-square_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgUserSquare;